var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isStoreFont & !_vm.isUser)?_c('div',{staticClass:"sf_hide",on:{"click":_vm.handleSfHide}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }